export const DEFERRED_PAYMENTS_PIN_LENGTH = 6;
export const MOLLIE_SIGNUP_LINK =
  "https://www.mollie.com/dashboard/signup/11580407?lang=be";
